// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"358":"78a973cc","371":"3cf5242a","491":"8abd1403","726":"8450fe48","898":"b932c889"}[chunkId] + ".chunk.js";
};